import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { Input, HelpBlock } from "components/bootstrap";
const StyledField = styled(Field)`
  &&[type='checkbox'] {
    margin-top: 8px;
  }
`;
const BooleanField = ({ field, name, error, title }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Input, { id: `${name}-input`, label: title, error, labelClassName: "col-sm-11", wrapperClassName: "col-sm-1" }, /* @__PURE__ */ React.createElement(StyledField, { id: `${name}-input`, type: "checkbox", className: "pull-right", "aria-label": field.title, name })), /* @__PURE__ */ React.createElement(HelpBlock, null, field.description));
export default BooleanField;
